module.exports = __webpack_public_path__ + "static/media/26UNRWA18.bdb2e615.jpg";